import React from "react";
import { getStories } from "../../api";
import axios from "axios";
import severUrl from "../../api";

class NLP extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            stories: []
        };
    }

    componentDidMount() {
        var bodyFormData = new FormData();
        bodyFormData.append("topic_id", 1);
        axios.post(severUrl + "blog/post/story/", bodyFormData).then((response) => {
            this.setState({ stories: response.data })
            // console.log(response)
        })
    }

    render() {
        return (
            <>
                <p style={{fontWeight:"bold"}}>NLP (Natural Language Processing)</p>
                <p className="simple-text-md">Natural Language Processing is subfield of AI concern how computer can understand the Language in texture</p>
                <p className="simple-text-md">The topics related to NLP task.</p>
                <ul style={{display:"list-item", content: "• ", listStyleType:"circle"}}>
                    <li>Sentiment Analysis</li>
                    <li>Hate Speech Detection</li>
                    <li>Text Summarization</li>
                </ul>
                {
                    this.state.stories.map((item, i) => {
                        return (
                            <p>
                                <a
                                    style={
                                        {
                                            fontSize: "22px",
                                            fontWeight: "0.4"
                                        }
                                    }
                                    href={`/${item.slug}`}>{item.title}</a>
                            </p>
                        );
                    })
                }
            </>
        );
    }
}

export default NLP;
